<script lang="ts" setup>
import { computed } from "vue";
import DeliveryRouteFreightItem from "@/views/trips/edit/components/DeliveryRouteFreightItem.vue";
import { useFreightOrdinals, useFreights } from "@/composables";
import type { OrderFreightDto } from "@/api/orders/dto/order.dto";
import type { TripRoute, TripRouteFreight, TripRouteStop } from "@/types/trip";
import { getEntityKey } from "@/utils/sameEntity";

const updatedStopFreights = defineModel<TripRouteFreight[]>({ required: true });

const props = defineProps<{
  orderFreight: OrderFreightDto;
  routeFreights: TripRouteFreight[];
  stop: TripRouteStop;
  routeStops: TripRouteStop[];
  route: TripRoute;
}>();

const emit = defineEmits<{
  (e: "open-stop-dialog", routeStop: TripRouteStop): void;
}>();

const { getFreightOrdinalLabel } = useFreightOrdinals(() => props.routeStops);
const { getFreightName } = useFreights();

const namedRouteFreights = computed(() => {
  return props.routeFreights
    .filter((rf) => {
      return rf.freightId === props.orderFreight.id;
    })
    .map((rf, i) => {
      const label = getFreightOrdinalLabel(getEntityKey(rf));
      return { ...rf, number: i + 1, name: getFreightName(rf, label, "", false, true) };
    });
});
</script>

<template>
  <div class="bg-grey-lighten-5 pa-4 rounded-b freight-border">
    <div class="text-grey-darken-2 mb-4">Select route freight(s) to be delivered to this stop:</div>
    <delivery-route-freight-item
      v-for="routeFreight in namedRouteFreights"
      :key="getEntityKey(routeFreight)"
      v-model="updatedStopFreights"
      :route="route"
      :route-freight="routeFreight"
      :route-stops="routeStops"
      :stop="stop"
      @open-stop-dialog="(freight) => emit('open-stop-dialog', freight)"
    />
  </div>
</template>
